import { Component, OnInit } from '@angular/core';

import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusService } from 'src/app/core/services/api/campus.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

    public campus: Campus;
    public webResourceId: string = "contact-page";

    constructor(private campusService: CampusService) { }

    ngOnInit() {

        this.campus = this.campusService.campusActive;

    }

}
